import { ComponentPropsWithoutRef, FC } from "react";

type DropdownMenuDividerProps = {
  size?: "s" | "m";
} & ComponentPropsWithoutRef<"hr">;

const DropdownMenuDivider: FC<DropdownMenuDividerProps> = ({
  size = "m",
  ...rest
}) => {
  const sizeClasses = {
    s: "mx-2 my-1",
    m: "mx-3 my-1",
  };
  return (
    <hr
      {...rest}
      className={`${rest.className} border-border ${
        sizeClasses[size ?? "m"]
      }`}
    />
  );
};

export default DropdownMenuDivider;
